import { Button, DrawerBody, DrawerFooter, Loading, SubmitButton } from "@dgs/core";
import { Formik } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DataFieldIndexResource } from "../../../../shared/types/dataField";
import { ContactDataFieldField } from "../ContactDataFieldField";
import { CreateContactStepForm, DrawerForm, FormActions } from "./Form";

export type DetailsFormValues = Record<string, unknown>;

interface Props extends CreateContactStepForm<DetailsFormValues> {
	dataFields: DataFieldIndexResource[];
	onGoBack: () => void;
}

export const emptyDetailsFormValues: DetailsFormValues = {};

export const DetailsForm: FC<Props> = ({ dataFields, onGoBack, initialValues, onSubmit }) => {
	const { t } = useTranslation();

	if (!dataFields) {
		return (
			<DrawerBody>
				<Loading />
			</DrawerBody>
		);
	}

	return (
		<Formik initialValues={initialValues} onSubmit={onSubmit}>
			<DrawerForm>
				<DrawerBody>
					{dataFields.map((dataField) => (
						<ContactDataFieldField key={dataField.id} dataField={dataField} name={String(dataField.id)} />
					))}
				</DrawerBody>
				<DrawerFooter>
					<span />
					<FormActions>
						<Button type="button" onClick={onGoBack}>
							{t("Back")}
						</Button>
						<SubmitButton>{t("Next")}</SubmitButton>
					</FormActions>
				</DrawerFooter>
			</DrawerForm>
		</Formik>
	);
};
